import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { Subject } from "rxjs";
import {
  PopoverButton,
  PopoverEquipment,
  PopoverOptions,
} from "src/app/app/_component/popover/popover.model";
import { globalHelper } from "src/app/_helpers/global";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-add-invitation-space-view",
  templateUrl: "./add-invitation-space-view.component.html",
  styleUrls: ["./add-invitation-space-view.component.scss"],
})
export class AddInvitationSpaceViewComponent implements OnInit {
  constructor(
    public spaceServ: SpaceService,
    public popoverController: PopoverController,
    public p: ThisPlatform
  ) {}

  showEquipmentsListButton: boolean = false;

  @Input()
  spaceAdded: boolean = false;

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  actionButton: string;

  @Input()
  actionButtonDisabled: boolean;

  @Input()
  styleClass;

  @Input()
  customData: string;

  @Input()
  spaceType: SpaceType;

  @Input()
  customDataSubject: Subject<any> = new Subject<any>();

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    if (this.row.equipments.length > 0) {
      this.showEquipmentsListButton = true;
    }
  }

  onToggleInvitationSpace(event) {
    // Zaznaczanie tylko jednej salki konferencyjnej
    // Warunki umożliwiające zaznaczeninie więcej niż jednej salki konferencyjnej
    // this.spaceAdded = !this.spaceAdded;

    event.preventDefault();
    event.stopPropagation();
    this.actionRequest.emit(this.row);
  }

  async presentPopover(event: any) {

    event.preventDefault();
    event.stopPropagation();
    let popover = await globalHelper.Popover(
      this.popoverController,
      event,
      null,
      "user-assignment-view-share__popover",
      "SPACE.ROOM.EQUIPMENT",
      null,
      this.row.equipments
    );
  }
}
